import { useEffect, useState } from "react";
import { LoadPanel } from "devextreme-react";
import axios from "axios";
import { Toster } from "../../../components/Toster/Toster";
import { DynamicTabb } from "../../../components/DynamicTab/DynamicTab";
import { Table2 } from "../../../components/Table2/Table2";
import AdminCrumbs from "../components/AdminCrumbs";

const ServiceBusPage = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });

  const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

  const Tablecoloum = [
    { title: "Sequence Number", customwidth: "150px" },
    { title: "Device ID", customwidth: "120px" },
    { title: "Serial Number", customwidth: "150px" },
    { title: "Old Status", customwidth: "220px" },
    { title: "New Status", customwidth: "220px" },
    { title: "Published Date", customwidth: "200px" },
    { title: "Enqueued Time", customwidth: "200px" },
  ];

  const setTableData = (apiData) => {
    const arr = apiData.map((val) => ({
      ID: val.sequenceNumber,
      "Sequence Number": val.sequenceNumber,
      "Device ID": val.deviceId,
      "Serial Number": val.serialNumber,
      "Old Status": val.oldStatus,
      "New Status": val.newStatus,
     "Published Date": formatDate(val.publishedDateTime),
    "Enqueued Time": formatDate(val.enqueuedTimeUtc),
      obj: val,
    }));

    setData(arr);
  };

  const getRecentItems = () => {
    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/ServiceBus/recent-items`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: localStorage.getItem("pathURL"),
          gUserId: localStorage.getItem("gUserId"),
        },
      })
      .then((res) => {
        if (res?.data?.isSuccess) {
          setTableData(res?.data?.data || []);
        } else {
          setData([]);
          setToastConfig({
            isVisible: true,
            type: "error",
            message: res?.data?.message || "Failed to load Service Bus items",
          });
        }

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setToastConfig({
          isVisible: true,
          type: "error",
          message: "Failed to load Service Bus items",
        });
        setTimeout(() => setToastConfig({ isVisible: false, message: "", type: "" }), 2000);
      });
  };

  const importItems = () => {
    const itemsToImport = selectedRows?.length ? selectedRows.map((x) => x.obj) : data.map((x) => x.obj);

    if (!itemsToImport.length) {
      setToastConfig({
        isVisible: true,
        type: "warning",
        message: "No records available to import",
      });
      return;
    }

    setLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/ServiceBus/import-items`, itemsToImport, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: localStorage.getItem("pathURL"),
          gUserId: localStorage.getItem("gUserId"),
        },
      })
      .then((res) => {
        setLoading(false);

        setToastConfig({
          isVisible: true,
          type: res?.data?.isSuccess ? "success" : "error",
          message: res?.data?.message || "Import completed",
        });
        setTimeout(() => setToastConfig({ isVisible: false, message: "", type: "" }), 2000);
      })
      .catch(() => {
        setLoading(false);
        setToastConfig({
          isVisible: true,
          type: "error",
          message: "Failed to import Service Bus records",
        });
        setTimeout(() => setToastConfig({ isVisible: false, message: "", type: "" }), 2000);
      });
  };

  useEffect(() => {
    getRecentItems();
  }, []);

  return (
    <>
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <LoadPanel shadingColor="true" visible={loading} delay={10} />

      <AdminCrumbs title="Service Bus" user="Data" />

      <div className="fee-schedule-container">
        <DynamicTabb />

        <div className="fee-schedule-content">
          <p className="page-info-number">SB.1</p>

          <div className="fee-schedule-buttons">
            <div className="buttons">
              <button className="btn" onClick={getRecentItems}>
                Refresh
                <svg
                  className="svg-blue-white"
                  width="16"
                  height="21"
                  viewBox="0 0 16 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.99905 4.00003V1.21003C7.99905 0.760031 7.45905 0.540031 7.14905 0.860031L3.34905 4.65003C3.14905 4.85003 3.14905 5.16003 3.34905 5.36003L7.13905 9.15003C7.45905 9.46003 7.99905 9.24003 7.99905 8.79003V6.00003C11.7291 6.00003 14.6791 9.42003 13.8591 13.29C13.3891 15.56 11.5491 17.39 9.28905 17.86C5.71905 18.61 2.53905 16.16 2.05905 12.85C1.98905 12.37 1.56905 12 1.07905 12C0.479051 12 -0.000948563 12.53 0.0790514 13.13C0.699051 17.52 4.87905 20.77 9.60905 19.85C12.7291 19.24 15.2391 16.73 15.8491 13.61C16.8391 8.48003 12.9391 4.00003 7.99905 4.00003Z"
                    fill="#424167"
                  />
                </svg>
              </button>

              <button className="btn" onClick={importItems}>
                Import
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path d="M5 20H19V18H5V20ZM12 2L7 7H10V14H14V7H17L12 2Z" fill="#424167" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <Table2
          Tablecoloum={Tablecoloum}
          tableRow={data}
          editTable={false}
          load={loading}
          coloumWidthText={"ServiceBus"}
          height={"auto"}
          showTotalBlock={false}
          exportwidth={16.3}
          setSelectedRows={setSelectedRows}
          mandatoryColoum={"Sequence Number"}
        />
      </div>
    </>
  );
};

export default ServiceBusPage;
